import React, { useState } from 'react';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { FaceScanInfoModal } from './FaceScanInfoModal';
import './FaceScanWidget.css';

type Props = {
  className?: string;
};

const FaceScanWidget: React.FC<Props> = ({ className }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div className={`facescan-widget ${className || ''}`}>
      <div className="hoverable cursor-pointer" role="button" onClick={() => setModalShow(true)}>
        <img 
          src={toAbsoluteUrl('/media/partner/facescan.png')} 
          width="100%" 
          alt="Face Scan" 
          className="card-p-5 shadow rounded-corners" 
        />
      </div>
      <FaceScanInfoModal show={modalShow} handleClose={() => setModalShow(false)} />
    </div>
  );
};

export { FaceScanWidget };
